import { gql, useMutation } from "@apollo/client";

import {
  AddDeviceInput,
  BatchAddDevicesMutation,
  BatchAddDevicesMutationVariables,
} from "../../../API";
import { BATCH_ADD_DEVCIES } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useCreateBatchDevices = () => {
  const [saveBatchCreateDevices, { data, loading }] = useMutation<
    BatchAddDevicesMutation,
    BatchAddDevicesMutationVariables
  >(BATCH_ADD_DEVCIES);

  const batchCreateDevices = async (input: AddDeviceInput[]) => {
    return await saveBatchCreateDevices({
      variables: {
        input,
      },
      awaitRefetchQueries: true,
      onError: handleApolloError,
      update: async (cache, response) => {
        cache.modify({
          fields: {
            getDevices(existing) {
              const newDevicesRefs =
                response?.data?.batchAddDevices?.map(d => {
                  return cache.writeFragment({
                    data: d,
                    fragment: gql`
                      fragment NewDevice on Device {
                        customerId
                        deviceData
                        id
                        cameraIpAddress
                        locationId
                        locationName
                        makeModelId
                        name
                        nodeId
                        nodeName
                        status
                      }
                    `,
                  });
                }) ?? [];

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, ...newDevicesRefs],
              };
            },
          },
        });
      },
    });
  };

  return {
    batchCreateDevices,
    data,
    loading,
  };
};
